var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fb",
    transform: "translate(-64.193 -1012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    transform: "translate(64.193 1012)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "facebook_1_",
    "data-name": "facebook (1)",
    d: "M12.952,4.474h1.4V2.1A19.459,19.459,0,0,0,12.311,2,3.2,3.2,0,0,0,8.9,5.5V7.455H6.61v2.653H8.9v6.8H11.64v-6.8h2.28l.343-2.653H11.64V5.764C11.64,4.981,11.849,4.474,12.952,4.474Z",
    transform: "translate(67.872 1017.643)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.50ab533d6694588b83af854ebec06d49.svg";
export { ForwardRef as ReactComponent };